import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import ConsentCheckboxField from "./ConsentCheckboxField";

interface TermsConsentCheckBoxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  style?: React.CSSProperties;
}

const TermsConsentCheckBox = ({
  checked,
  onCheckedChange,
  style,
}: TermsConsentCheckBoxProps) => {
  const termsPdfPath = "/iceholidays-assets/ground_terms_v2.pdf";
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageWidth, setPageWidth] = useState(900);

  useEffect(() => {
    const updatePageWidth = () => {
      const width = Math.min(900, Math.max(window.innerWidth - 48, 280));
      setPageWidth(width);
    };

    updatePageWidth();
    window.addEventListener("resize", updatePageWidth);

    return () => {
      window.removeEventListener("resize", updatePageWidth);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages: loadedPages }: { numPages: number }) => {
    setNumPages(loadedPages);
  };

  return (
    <ConsentCheckboxField
      name="terms_agreed"
      checked={checked}
      onCheckedChange={onCheckedChange}
      linkLabel="Terms of Use"
      requiredMessage="Please agree to the Terms of Use to proceed to payment."
      modalTitle="Terms of Use"
      modalContent={
        <div>
          <Document
            file={termsPdfPath}
            onLoadSuccess={onDocumentLoadSuccess}
            error="There is no terms document available."
            loading="Loading terms document..."
          >
            {Array.from(new Array(numPages || 0), (_, index) => (
              <Page key={`terms_page_${index + 1}`} pageNumber={index + 1} width={pageWidth} />
            ))}
          </Document>
          <a href={termsPdfPath} target="_blank" rel="noreferrer">Open Terms of Use PDF in new tab</a>
        </div>
      }
      style={style}
    />
  );
};

export default TermsConsentCheckBox;
